import { useState } from "react";
import { IPresenterProps } from './types';
import { CustomInput, CustomView } from './styles';

const InputPresenter = (props: IPresenterProps) => {
    const [isFocused, setFocus] = useState(false);

    return (
        <CustomView bgColor={props.bgColor}>
            <CustomInput
                type={props.inputType}
                placeholder={props.placeHolder}
                value={props.value}
                onChange={props.onChange}
                onFocus={(e) => { setFocus(true) }}
                onBlur={(e) => {
                    setFocus(false);
                    if (props.onBlur) {
                        props.onBlur();
                    }
                }}
                isFocused={isFocused}
                showError={props.showError}
                disabled={props.disabled}
                textColor={props.textColor}
                maxLength={props.maxLength}
                placeHolderColor={props.placeHolderColor}
            />

            {/* {props.showError &&
                <AlertDiv>
                    <Alert />
                </AlertDiv>
            } */}
        </CustomView>
    )
};

export default InputPresenter;
